import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import {
  AllocateActionRequestModel,
  AllocationByRuleActionRequestModel,
  AllocationDetailsModel,
  AllocationManualActionRequestModel,
  AllocationResponseModel,
  AllocationUliDocksResponse,
  AllocationUliRuleSlot,
  AllocationUliRulesResponse,
  AllocationViewActionIdentifierModel,
  AllocationViewTimeslotOutputModel,
  AllocationViewTimeslotRequestModel,
} from '../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewAllocateActionService {
  constructor(private http: WrapperHttpService) {}

  getAllocationDetails(identifier: AllocationViewActionIdentifierModel): Observable<AllocationDetailsModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Details}`;
    return this.http.withLoading().post<AllocationDetailsModel>(url, identifier);
  }

  updateAllocationDetails(body: AllocationDetailsModel): Observable<AllocationDetailsModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Details}${AllocationViewEndpoint.Update}`;
    return this.http.withLoading().post<AllocationDetailsModel>(url, body);
  }

  getAllocationDocks(body: AllocateActionRequestModel): Observable<AllocationUliDocksResponse> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Docks}`;
    return this.http.withLoading().post<AllocationUliDocksResponse>(url, body);
  }

  getAllocationRules(body: AllocateActionRequestModel): Observable<AllocationUliRulesResponse> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Rules}`;
    return this.http.withLoading().post<AllocationUliRulesResponse>(url, body);
  }

  getAllocationRuleSlots({
    details,
    ruleId,
  }: {
    details: AllocationDetailsModel;
    ruleId: number;
  }): Observable<AllocationUliRuleSlot[]> {
    const url =
      `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Rules}/${ruleId}${AllocationViewEndpoint.Slots}?` +
      getQueryStringFromObject({ hubId: details.hubId });
    return this.http.withLoading().post<AllocationUliRuleSlot[]>(url, details);
  }

  getProposedTimeslot({
    compartmentId,
    dockId,
    details,
  }: AllocationViewTimeslotRequestModel): Observable<AllocationViewTimeslotOutputModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Compartments}/${compartmentId}${AllocationViewEndpoint.Docks}/${dockId}${AllocationViewEndpoint.Slot}`;
    return this.http.withLoading().post<AllocationViewTimeslotOutputModel>(url, details);
  }

  manualAllocateUli(body: AllocationManualActionRequestModel): Observable<AllocationResponseModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Manual}`;
    return this.http.withLoading().post<AllocationResponseModel>(url, body);
  }

  autoAllocateUli(body: AllocateActionRequestModel): Observable<AllocationResponseModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.Auto}`;
    return this.http.withLoading().post<AllocationResponseModel>(url, body);
  }

  allocateByRuleUli(body: AllocationByRuleActionRequestModel): Observable<AllocationResponseModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.Allocate}${AllocationViewEndpoint.ByRule}`;
    return this.http.withLoading().post<AllocationResponseModel>(url, body);
  }
}
